import React from "react";
import { MdDownload } from "react-icons/md";
import { printMultipleFiles } from "../ActionDropDown/printMultipleFiles";
import { useTranslation } from "react-i18next";

const isLive = (shipment) =>
  shipment && shipment?.shipment_status?.toLowerCase() !== "cancelled";

const DocButton = ({ label, title, onClick }) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    onClick={onClick}
    className="inline-flex h-[18px] shrink-0 items-center gap-[2px] rounded-[4px] border-[1px] border-ui-border bg-ui-surface px-[5px] text-[10px] font-medium leading-none text-ui-text-muted transition-colors hover:border-brand hover:text-brand"
  >
    <MdDownload size={10} aria-hidden="true" />
    {label}
  </button>
);

/**
 * Label and Decl downloads for the Shipping column of Warehouse Orders, with
 * the same rules and downloads as the old buttons in the Actions column; a
 * button only shows when it can download something (the old ones were
 * greyed out and couldn't be clicked otherwise). The row menu still has both.
 */
const ShippingDocs = ({ row, printLabel, printDeclaration }) => {
  const { t } = useTranslation("warehouse");
  const manual = row?.manual_shipment;
  const manualLabels = manual?.shipping_labels?.length > 0;
  const manualDeclarations = manual?.shipping_declarations?.length > 0;

  const hasLabel = isLive(row?.shipment) || manualLabels;
  const hasDeclaration =
    (isLive(row?.shipment) && row?.shipment?.single_shipping_invoice) ||
    manualDeclarations;

  if (!hasLabel && !hasDeclaration) return null;

  return (
    <span className="flex shrink-0 items-center gap-[4px]">
      {hasLabel && (
        <DocButton
          label={t("orders.label")}
          title={t("orders.downloadShippingLabel")}
          onClick={() =>
            manualLabels
              ? printMultipleFiles(
                  manual?.shipping_labels,
                  manual?.shipment_tracking_id,
                )
              : printLabel(row)
          }
        />
      )}
      {hasDeclaration && (
        <DocButton
          label={t("orders.decl")}
          title={t("orders.downloadShipmentDeclaration")}
          onClick={() =>
            manualDeclarations
              ? printMultipleFiles(
                  manual?.shipping_declarations,
                  manual?.shipment_tracking_id,
                )
              : printDeclaration(row)
          }
        />
      )}
    </span>
  );
};

export default ShippingDocs;
